import { Navigate, Routes, Route } from 'react-router-dom';
import { Login } from '../auth/Login';
import { PrivacyNoticeGate } from '../../components/layout/PrivacyNoticeGate';
import { TrainingShell } from '../../components/layout/TrainingShell';
import { TrainingHome } from './TrainingHome';
import { TrainingPlayer } from '../me/TrainingPlayer';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

/**
 * The training portal route tree (training.corrigenda.co.uk). Aimed at
 * existing staff, so it deliberately exposes only training surfaces: a
 * learner landing and the module player, inside TrainingShell. None of the
 * mobilisation / onboarding / admin routes exist here. Unknown paths fall
 * back to the home page rather than the main app's 404 surfaces.
 */
export function TrainingApp() {
  // index.html says "Onboarding" for the main app; this tree renames the tab.
  useDocumentTitle('Corrigenda Training');

  return (
    <>
      <PrivacyNoticeGate />
      <Routes>
        {/* Public: shared login card (generic Corrigenda branding). */}
        <Route path="/login" element={<Login />} />

        <Route element={<TrainingShell />}>
          <Route path="/" element={<TrainingHome />} />
          <Route
            path="/me/training/:taskId"
            element={<TrainingPlayer backTo="/" backLabel="Back to your training" />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}
